import React, { Component } from 'react'
import { Container, Form, Col, Button, Table } from 'react-bootstrap'
import axios from 'axios'

import { AdminNav,Loading } from '../../helpers'
import { Redirect } from 'react-router-dom'
import { convertRiceTypeENToTH } from '../../helpers/function';
import {similarity} from '../../helpers/functionForJob'
class AddJob extends Component {
  constructor(props) {
    super(props)
    this.state = {
      validated: false,
      validatedLicense: false,
      Officer: null,
      fName: '',
      lName: '',
      surveyID: '2',
      chainID : '',
      RequestSheetChain:'',
      redirect: false,
      shippingDate: this.props.location.state.shippingDate,
      surveyCompany: this.props.location.state.surveyCompany,
      requestBy: this.props.location.state.requestBy, 
      surveyLocateName: this.props.location.state.surveyLocateName,
      description: this.props.location.state.description,
      requestID: this.props.location.state.requestID,
    }
    this.similarPlace = this.similarPlace.bind(this)
  }
  componentWillMount() {
    let viewCompanyPromise = axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {

        action: 'viewCompany',
        data: { 'companyID': this.props.location.state.companyID },

      }
    )
    let viewAllOfficerPromise = axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {

        action: 'viewAllOfficer',
      }
    )
    Promise.all([viewCompanyPromise,viewAllOfficerPromise])
    .then((res)=>{
      let companyNameEN = res[0].data
      let Officer = res[1].data
      this.setState({
        ...this.state,
        companyNameEN : this.getCompanyName(companyNameEN),
        Officer : Officer,
      })
    })
    let shortcut = this.props.location.state
    this.similarPlace(shortcut['surveyDistrict'],shortcut['surveyProvince'],shortcut['surveyLocateName'])
  }

  componentDidMount() {
    // console.log(this.state)

  }

  createJob = () => {
    axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        action: 'approveSurveyRequest',
        data: this.state,
      }
    ).then(res => {
      if (res.data.jobID) {
        this.setState({
          ...this.state,
          redirect: true,
        })
      }
    })
  }
  getCompanyName(data) {
    let a = Object.keys(data).map((res) => {
      let c = data[res]
      return (c.companyNameEN)
    })
    return (a[0])
  }

  HandleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
  }
  handleSubmit(event) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (form.checkValidity() === true) {
      event.preventDefault();
      this.setState({ dataReady: true })
      this.createJob()
    }
    this.setState({ validated: true });
  }
  handleSubmitAll = () => {
    this.refs.form1.dispatchEvent(new Event('submit'))
  }
  HandleSurveyorChange = (e) => {
    let a = this.state.Officer[e.target.value]
    if(a){
      this.setState({
        ...this.state,
        officerID: a.ID.toString(),
        fName: a.fName,
        lName: a.lName,
      })  
    }else{
      this.setState({
        ...this.state,
        officerID: '',
        fName: '',
        lName: '',
      })  
    }
  }
  HandleSurveyorChange2 = (e) => {
    let a = this.state.Officer[e.target.value]
    if(a){
      this.setState({
        ...this.state,
        officerID2: a.ID.toString(),
        fName2: a.fName,
        lName2: a.lName,
      })
    }else{
      this.setState({
        ...this.state,
        officerID2: '',
        fName2: '',
        lName2: '',
      })
    }
  }
  handleChain = (e)=>{
    this.setState({
      ...this.state,
      chainID : e.target.value
    })
  }
  renderRedirectToJob(e) {
    if (this.state.redirect) {
      // console.log(this.props.history.location)
      this.props.history.push({
        pathname: '/Job',
        state: this.props.history.location.date,
      })
    }
  }
  similarPlace(targetDistrict , targetProvince, targetPlace){
    if(this.props.history.location.RequestSheetChain){
      let arr = this.props.history.location.RequestSheetChain.filter((data)=>{
        return data['surveyProvince'] == targetProvince && data['surveyDistrict'] == targetDistrict && data != this.props.location.state
      })
      let newArr = []
      arr.forEach((e,idx)=>{ newArr.push([similarity(targetPlace,e['surveyLocateName']),idx])})
      newArr = newArr.sort().reverse()
      let outputArr = []
      newArr.forEach((e)=>{
        outputArr.push(arr[e[1]])
      })
      return outputArr  
    }else{
      return []
    }
  }
  render() {
    const { validated,Officer } = this.state;
    let shortcut = this.props.location.state
    if (!Officer) {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading />
      </Container>
      )
    }

    return (
      <Container>
        {this.renderRedirectToJob()}
        <AdminNav></AdminNav>
        <Form
          ref="form1"
          noValidate
          validated={validated}
          onSubmit={e => this.handleSubmit(e)}
        >
          <Form.Row>
            <Form.Group as={Col} md="5">
              <Form.Label>ชื่อบริษัท</Form.Label>
              <Form.Control type="text" required id="companyNameEN" onChange={this.HandleChange} value={this.state.companyNameEN}>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                โปรดระบุ
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="5">
              <Form.Label>วันบรรทุกสินค้า</Form.Label>
              <Form.Control
                required
                type="date"
                id="shippingDate" onChange={this.HandleChange}
                value={this.state.shippingDate}
              />
              <Form.Control.Feedback type="invalid">
                กรุณาระบุวันที่
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            {/* <Form.Group as={Col} md="5">
              <Form.Label>ชื่อบริษัทตรวจสอบ</Form.Label>
              <Form.Control type="text" required id="surveyCompany" onChange={this.HandleChange} value={this.state.surveyCompany}>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                โปรดระบุ
              </Form.Control.Feedback>
            </Form.Group> */}
            <Form.Group as={Col} md="5">
              <Form.Label>ชื่อผู้ขอตรวจสอบ</Form.Label>
              <Form.Control type="text" required id="requestBy" onChange={this.HandleChange} value={this.state.requestBy} />
              <Form.Control.Feedback type="invalid">
                กรุณาระบุชื่อผู้ขอตรวจสอบ
              </Form.Control.Feedback>
            </Form.Group>



          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} md="3">
              <Form.Label>สถานที่ตรวจสอบ</Form.Label>
              <Form.Control type="text" id="surveyLocateName" onChange={this.HandleChange} value={this.state.surveyLocateName} />
              <Form.Control.Feedback type="invalid">
                กรุณาระบุ
              </Form.Control.Feedback>
            </Form.Group>{console.log(this.props.location.state)}
            <Form.Group as={Col} md="3">
              <Form.Label>สถานที่ตรวจสอบ (EN)</Form.Label>
              <Form.Control type="text" id="godown" onChange={this.HandleChange} value={this.props.location.state.godown} required />
              <Form.Control.Feedback type="invalid">
                กรุณาระบุ
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="3">
              <Form.Label>อำเภอ</Form.Label>
              <Form.Control type="text" id="surveyDistrict" onChange={this.HandleChange} value={this.props.location.state.surveyDistrict} required />
              <Form.Control.Feedback type="invalid">
                กรุณาระบุ
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="3">
              <Form.Label>จังหวัด</Form.Label>
              <Form.Control type="text" id="surveyProvince" onChange={this.HandleChange} value={this.props.location.state.surveyProvince} required />
              <Form.Control.Feedback type="invalid">
                กรุณาระบุ
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Form.Control style={{ display: 'none' }} type="submit" />
          <Form.Row>
            <Form.Group as={Col} md="4">
              <Form.Label>พนักงานตรวจข้าว</Form.Label>
              <Form.Control required as="select" id="officerID" onChange={this.HandleSurveyorChange}>
                <option value="">โปรดเลือก</option>
                {Object.keys(this.state.Officer).map((res) => {
                  let c = this.state.Officer[res]
                  return (
                    <option value={res}>{parseInt(c.userName)+1} {c.fName}</option>
                  )
                })}
              </Form.Control>
            </Form.Group>
            <Col md="4">
              <Form.Label>ชื่อ</Form.Label>

              <Form.Control plaintext readOnly defaultValue={this.state.fName} />
            </Col>
            <Col md="4">
              <Form.Label>นามสกุล</Form.Label>
              <Form.Control plaintext readOnly defaultValue={this.state.lName} />
            </Col>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} md="4">
              <Form.Label>พนักงานตรวจข้าว</Form.Label>
              <Form.Control as="select" id="officerID2" onChange={this.HandleSurveyorChange2}>
                <option value="">โปรดเลือก</option>
                {Object.keys(this.state.Officer).map((res) => {
                  let c = this.state.Officer[res]
                  return (
                    <option value={res}>{parseInt(c.userName)+1} {c.fName}</option>
                  )
                })}
              </Form.Control>
            </Form.Group>
            <Col md="4">
              <Form.Label>ชื่อ</Form.Label>

              <Form.Control plaintext readOnly defaultValue={this.state.fName2} />
            </Col>
            <Col md="4">
              <Form.Label>นามสกุล</Form.Label>
              <Form.Control plaintext readOnly defaultValue={this.state.lName2} />
            </Col>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} md="4">
              <Form.Label>ต่อ</Form.Label>
              <Form.Control as="select" id="chain" onChange={this.handleChain}>
                <option value="">โปรดเลือก</option>
                {this.similarPlace(shortcut['surveyDistrict'],shortcut['surveyProvince'],shortcut['surveyLocateName']).map((res) => {
                  return (
                    <option value={res['requestID']}>{`${res['requestID']} ${res['surveyLocateName']} ${res['surveyDistrict']} ${res['surveyProvince']} `}</option>
                  )
                })}
              </Form.Control>
            </Form.Group>
            </Form.Row>
        </Form>
        <Table responsive>
          <col width="80"></col>
          <col width="150"></col>
          <col width="90"></col>
          <col width="80"></col>
          <col width="120"></col>
          <col width="150"></col>
          <col width="150"></col>
          <col width="80"></col>
          <col width="110"></col>
          <col width="90"></col>

          <thead>
            <tr>
              <th>ลำดับที่</th>
              <th>เลขที่ใบอนุญาต</th>
              <th>ชนิดข้าว</th>
              <th>ปริมาณ</th>
              <th>ชนิดกระสอบ</th>
              <th>น้ำหนักรวมกระสอบ</th>
              <th>น้ำหนักไม่รวมกระสอบ</th>
              <th>สัญลักษณ์</th>
              <th>บรรทุกโดย</th>
              <th>จุดหมาย</th>
            </tr>
          </thead>
          <tbody>
            {this.state.description.map((data, idx) => (
              <tr>
                <td>{idx + 1}</td>
                <td>{data.licenseID}</td>
                <td>{data.riceTypeID}</td>
                <td>{data.quantity}</td>
                <td>{data.bagType}</td>
                <td>{data.netWeight}</td>
                <td>{data.grossWeight}</td>
                <td>{data.logo}</td>
                <td>{data.vehicleName}</td>
                <td>{data.destinationCity}</td>
              </tr>
            ))}

          </tbody>

        </Table>
        <Button style={{ float: 'right' }} onClick={this.handleSubmitAll}>ยืนยัน</Button>

      </Container>
    )
  }

}

export default AddJob
